import { Markup } from 'interweave';

export const columnsAnswer = [
    {
        field: 'title',
        header: 'modals.activity.execution.empty.answer',
        isMain: true,
    },
    {
        field: 'completion',
        header: 'modals.news_execution.approval.stores_detail.table.header.completion',
        isMain: true,
    },
    {
        field: 'answer',
        header: '',
        template: (rowData: any) => {
            return (
                <>{rowData.answer ? <div> <Markup content={rowData.answer}/> </div> : "/"}</>
            )
        },
    },
]
